<div class="p-fluid grid center-screen ">
  <div class="field col-4 md:col-6" >
    <ng-select inputId="dropdown" [(ngModel)]="cuentaSeleccionada" placeholder="Seleccione una cuenta">
      @for (cuenta of cuentas; track cuenta) {
        <ng-option [value]="cuenta">{{cuenta.nombre}}</ng-option>
      }
    </ng-select>

    <button class="btn btn-primary btn-sm mt-2" (click)="asignarCuenta();" [disabled]="!cuentaSeleccionada">
      <i class="bi bi-check2"></i> Confirmar
    </button>
  </div>
</div>

<!-- <pre >{{cuentas | json}}</pre> -->